import { combineReducers } from "redux";
import { authReducer } from './authReducer';
import { stockReducer } from './stockReducer';
import { movementReducer } from './movementReducer';
import { userReducer } from "./userReducer";
import { storeReducer } from "./storeReducer";
import { uiStoreReducer } from "./uiStoreReducer";
import { uiDeleteReducer } from "./uiDeleteReducer";
import { uiUserReducer } from "./uiUserReducer";
import { uiPdfReducer } from "./uiPdfReducer";
import { importReducer } from "./importReducer";
import { uiReducer } from "./uiReducer";
import { downloadReducer } from "./downloadReducer";
import { spinnerReducer } from "./spinnerReducer";
import { deliveryReducer } from './deliveryReducer';
import { ssccReducer } from './ssccReducer';
import { cmpReducer } from './cmpReducer';
import { roleReducer } from './roleReducer';
import { uiOrdersOrDeliverysReducer } from './uiOrdersOrDeliverysReducer';

export const rootReducer = combineReducers({

    auth: authReducer,
    stock: stockReducer,
    movement: movementReducer,
    user: userReducer,
    store: storeReducer,
    uiStore: uiStoreReducer,
    uiDelete: uiDeleteReducer,
    uiUser: uiUserReducer,
    uiPdf: uiPdfReducer,
    uiOrdersOrDeliverys: uiOrdersOrDeliverysReducer,
    import: importReducer,
    ui: uiReducer,
    spinner: spinnerReducer,
    delivery: deliveryReducer,
    download: downloadReducer,
    sscc: ssccReducer,
    cmp: cmpReducer,
    roles: roleReducer,
});

export default rootReducer;